<script setup lang="ts">
import { computed, ref } from 'vue';
import { affiliateConfigs } from '~/utils/perfilOficialConfigs';

const searchQuery = ref('');

const affiliates = computed(() => {
  return Object.entries(affiliateConfigs);
});

const filteredAffiliates = computed(() => {
  if (!searchQuery.value.trim()) {
    return affiliates.value;
  }

  const query = searchQuery.value.toLowerCase().trim();

  return affiliates.value.filter(([affiliateName, config]) => {
    // Search in affiliate name
    const displayName = config.affiliateDetails?.name || affiliateName;

    if (displayName.toLowerCase().includes(query)) {
      return true;
    }

    // Search in categories
    if (
      config.categories.some((category) =>
        category.toLowerCase().includes(query),
      )
    ) {
      return true;
    }

    // Search in title/badge
    if (
      config.affiliateDetails?.title &&
      config.affiliateDetails.title.toLowerCase().includes(query)
    ) {
      return true;
    }

    return false;
  });
});
</script>

<template>
  <div class="container mx-auto min-h-[80vh]">
    <h1 class="text-2xl font-bold mb-4 text-center text-white">
      Perfis Oficiais: parceiros oficiais da Apostatudo
    </h1>

    <!-- Search Bar -->
    <div class="max-w-md mx-auto mb-6">
      <div class="relative">
        <input
          v-model="searchQuery"
          class="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent backdrop-blur-sm"
          placeholder="Buscar perfil..."
          type="text"
        />
        <div class="absolute inset-y-0 right-0 flex items-center pr-3">
          <svg
            class="w-5 h-5 text-white/50"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
        </div>
      </div>
    </div>

    <div
      class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 max-w-7xl place-items-center mb-4"
    >
      <PerfilOficialCard
        v-for="[affiliateName, config] in filteredAffiliates"
        :key="affiliateName"
        :affiliate-name="affiliateName"
        :config="config"
      />
    </div>
  </div>
</template>
